module.exports = __webpack_public_path__ + "static/lunchtype24-light-expanded-webfont-5afa09ac0132080996312ab0c4f20149.ttf";